export default {
  termeni_si_conditii: 'Termeni si conditii',
  pagina_termeni_si_conditii: 'termeni-si-conditii'
}
